import { render, staticRenderFns } from "./NetWorkDetect.vue?vue&type=template&id=8d10faac&scoped=true&"
import script from "./NetWorkDetect.vue?vue&type=script&lang=js&"
export * from "./NetWorkDetect.vue?vue&type=script&lang=js&"
import style0 from "./NetWorkDetect.vue?vue&type=style&index=0&id=8d10faac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d10faac",
  null
  
)

export default component.exports